import { Box } from '@mui/material';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import { useState } from 'react';

export default function Layout(props:{children:any}) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
            <Box sx={{ display: 'flex',flexDirection:'column'}}>
                <Box 
                    sx={theme => ({
                        transition: theme.transitions.create('margin-left', {
                            duration: theme.transitions.duration.standard,
                            easing: theme.transitions.easing.easeInOut,
                        }),
                        mt: 7, ml: {sm: menuOpen? 35:11, xs: 0}
                        })}
                        >                           
                    {props.children}
                    <Footer />
                </Box>
            </Box>
        </>
    )
}
